import { trustBadges } from '@/mocks/homeData';

const TrustBadges = () => (
  <section className="relative bg-background-50 py-14 md:py-20">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 md:gap-6">
        {trustBadges.map((badge) => (
          <div
            key={badge.label}
            className="flex flex-col items-center text-center p-6 rounded-2xl bg-background-100/60 border border-background-200/60 transition-all duration-300 hover:bg-background-100"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100/80 mb-3">
              <i className={`${badge.icon} text-accent-600 text-lg`}></i>
            </div>
            <span className="text-sm font-medium text-foreground-800">{badge.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TrustBadges;